import { render, staticRenderFns } from "./UnitPage.vue?vue&type=template&id=3ebbd908&scoped=true"
import script from "./UnitPage.vue?vue&type=script&lang=js"
export * from "./UnitPage.vue?vue&type=script&lang=js"
import style0 from "./UnitPage.vue?vue&type=style&index=0&id=3ebbd908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebbd908",
  null
  
)

export default component.exports